import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { BaseResponse } from 'src/types'
import { z } from 'zod'
import { SistemaTipo } from "../../../../../types/enum/enum"
import { HttpOperacionInforme } from "../../../api/httpOperacionInforme"
import {
    OperacionAFOCLTablaValorUpdate,
    OperacionAFOCLTablaValorVista,
    OperacionAFOCLInsert,
    schemaOperacionAFOCLTablaValorUpdate,
    schemaOperacionAFOCLTablaValorVista,
    schemaOperacionAFOCLInsert,
    OperacionAFOCLTablaValorVistaInicial,
    schemaOperacionAFOCLTablaValorVistaInicial,
    FormUpdateTablaValores,
    schemaFormUpdateTablaValores,
    OperacionAFOCLTablaValorHistorico,
    schemaOperacionAFOCLTablaValorHistorico,
    schemaOperacionAFOCLTablaValorHistoricoGrupo,
    OperacionAFOCLTablaValorHistoricoGrupo
} from '../types/dto'
import { OperacionAFOCL, schemaOperacionAFOCL } from '../types/types'

export const getEndpoint = (url = '') => `operaciones/AFOCL${url}`

export const HttpAFOCL = {
    get: (idOperacion: number): Promise<OperacionAFOCL> => {
        return HttpAxiosRequest.get(getEndpoint(`/${idOperacion}`))
            .then(response => {
                const parsed = schemaOperacionAFOCL.safeParse(response)
                if (!parsed.success) {
                    console.error('Error de validación:', parsed.error.issues)

                    return Promise.reject(new Error('Error de validación.'))
                }

                return parsed.data
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },

    post: (operacion: OperacionAFOCLInsert): Promise<BaseResponse> => {
        const parsed = schemaOperacionAFOCLInsert.safeParse(operacion)
        if (!parsed.success) {
            console.error('Error de validación xxx:', parsed.error.issues)

            return Promise.reject(new Error('Error de validación.'))
        }

        return HttpAxiosRequest.post(getEndpoint(), parsed.data)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },

    getTablaValoresInicial: (codUnidadNegocio: number, codSectorComercial: number): Promise<OperacionAFOCLTablaValorVistaInicial[]> => {
        const url = getEndpoint(`/0/tabla-valores/inicial/${codUnidadNegocio}/${codSectorComercial}`);
        const schemaResponse = z.array(schemaOperacionAFOCLTablaValorVistaInicial);

        return HttpAxiosRequest.get(url)
            .then(response => {
                const parsed = schemaResponse.safeParse(response);
                if (!parsed.success) {
                    console.error('Error de validación en getTablaValoresInicial:', parsed.error.issues);

                    return Promise.reject(new Error('Error de validación.'));
                }

                return parsed.data;
            })
            .catch(error => {
                console.error('Error de red en getTablaValores:', error);

                return Promise.reject('Error de red.');
            });
    },

    getTablaValores: (idOperacion: number): Promise<OperacionAFOCLTablaValorVista[]> => {
        const url = getEndpoint(`/${idOperacion}/tabla-valores`);
        const schemaResponse = z.array(schemaOperacionAFOCLTablaValorVista);

        return HttpAxiosRequest.get(url)
            .then(response => {
                const parsed = schemaResponse.safeParse(response);
                if (!parsed.success) {
                    console.error('Error de validación en getTablaValores:', parsed.error.issues);

                    return Promise.reject(new Error('Error de validación.'));
                }

                return parsed.data;
            })
            .catch(error => {
                console.error('Error de red en getTablaValores:', error);

                return Promise.reject('Error de red.');
            });
    },

    updateValor: (idOperacion: number, idCodTablaValor: number, valorUpdate: OperacionAFOCLTablaValorUpdate): Promise<BaseResponse> => {
        const parsed = schemaOperacionAFOCLTablaValorUpdate.safeParse(valorUpdate);
        if (!parsed.success) {
            console.error('Error de validación de entrada en updateValor:', parsed.error.issues);

            return Promise.reject(new Error('Error de validación.'));
        }

        const url = getEndpoint(`/${idOperacion}/tabla-valores/valores/${idCodTablaValor}`);

        return HttpAxiosRequest.put(url, parsed.data)
            .then(response => {
                return Promise.resolve(response);
            })
            .catch(error => {
                console.error('Error de red en updateValor:', error);

                return Promise.reject('Error de red.');
            });
    },


    getTablaValoresHistorico: (idOperacion: number): Promise<OperacionAFOCLTablaValorHistoricoGrupo[]> => {
        const url = getEndpoint(`/${idOperacion}/tabla-valores/historico`);
        const schemaResponse = z.array(schemaOperacionAFOCLTablaValorHistoricoGrupo);

        return HttpAxiosRequest.get(url)
            .then(response => {
                const parsed = schemaResponse.safeParse(response);
                if (!parsed.success) {
                    console.error('Error de validación en getTablaValoresHistorico:', parsed.error.issues);

                    return Promise.reject(new Error('Error de validación.'));
                }

                return parsed.data;
            })
            .catch(error => {
                console.error('Error de red en getTablaValores:', error);

                return Promise.reject('Error de red.');
            });
    },

    updateTablaValores: (idOperacion: number, datos: FormUpdateTablaValores): Promise<BaseResponse> => {
        const parsed = schemaFormUpdateTablaValores.safeParse(datos);
        if (!parsed.success) {
            console.error('Error de validación en updateTablaValores:', parsed.error.issues);
            
return Promise.reject(new Error('Error de validación.'));
        }

        const url = getEndpoint(`/${idOperacion}/tabla-valores`);

        return HttpAxiosRequest.put(url, parsed.data)
            .then(response => {
                return Promise.resolve(response);
            })
            .catch(error => {
                console.error('Error de red en updateTablaValores:', error);
                
return Promise.reject('Error de red.');
            });
    },

    descargarInforme: (idOperacion: number): Promise<any> =>
        HttpOperacionInforme.descargarInforme(idOperacion, SistemaTipo.AFOCL),

} as const